import script from "./detection-screen.vue?vue&type=script&setup=true&lang=js"
export * from "./detection-screen.vue?vue&type=script&setup=true&lang=js"

import "./detection-screen.vue?vue&type=style&index=0&id=750d7c5b&scoped=true&lang=css"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-750d7c5b"]])

export default __exports__